import React from 'react';
import clsx from 'clsx';
import { IProps } from './OptimizelyFormBlock.interface';
import './OptimizelyFormBlock.styles.css';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, {
    ContentColumn,
} from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import { OptimizelyForm } from '@/components/OptimizelyForm/OptimizelyForm.component';

export const OptimizelyFormBlock: React.FC<IProps> = ({
    className,
    title,
    form,
    ...blockWrapperProps
}) => {
    return (
        <BlockWrapper
            className={clsx('optimizelyFormBlock', className)}
            {...blockWrapperProps}
        >
            <ContentWrapper>
                <ContentColumn>
                    {title && (
                        <Heading
                            level={2}
                            className="optimizelyFormBlock__title"
                            html={title}
                        />
                    )}
                    {form && <OptimizelyForm form={form} />}
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};
